<!--  -->
<template>
<!-- 短视频案例 -->
  <div class="wow fadeInUp casepage mobile_wrap_short1">
    <el-row>
      <el-col :span="1" class="header_block"></el-col>
      <el-col :span="22" class="header_block" >
        <div class="ProgressBoxTool" v-if="progressList && progressList.length">
          <div class="prevBtn" ref="prevBtn"><img :src="require('@/assets/imgs/leftarror.png')"  class="server_img"  @click="fnPrev()" /></div>
          <div class="nextBtn" ref="nextBtn"><img :src="require('@/assets/imgs/rightarror.png')" class="server_img"  @click="fnNext()" /></div>
          <div class="processBox">
            <div class="fixedBox" :ref="`fixedBox`">
              <div
              
                class="centerScroll"
                :style="
              `width:${signleWidth *
                progressList.length}px;transform:translate(${scrollResultWidth}px,0);transition:1s;`
            "
              >
                <div
                  ref="aaa"
                  class="signleTab"
                  v-for="(itemP, indexP) in progressList"
                  :key="indexP + 'progress'"
                  @click="selectPics(itemP)"
                >
                  <!-- <div class="leftIcon"> -->
                  <img class="pregressIcon" ref="imgsIcon" :src="itemP.url" alt />
                  <div class="mask_title">{{itemP.text}}</div>
                  <!-- </div> -->
                  <!-- 最后一个不展示箭头 -->
                  <!-- <img
                v-if="progressList.length > indexP + 1"
                :src="iconArrow"
                alt=""
                class="arrowSquare"
                  />-->
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-col>
      <el-col :span="1" class="header_block"></el-col>
    </el-row>
    <!-- <el-row >
      <el-col :span="2" class="header_block"></el-col>
      <el-col :span="20" class="header_block" >
       <div class="posts-nav-wrap">
        	        <ul class="posts-nav">          	
                        <li class="previous" @click="fnPrev()"><a  class="previous">←</a></li>
                        <li class="next" @click="fnNext()"><a  class="next">←</a></li>
                    </ul>
            </div> 
      </el-col>
      <el-col :span="2" class="header_block"></el-col>
    </el-row> -->
  </div>
</template>
 
<script>
// import arrowL from '@/assets/images/emergency/arrowL.png';
// import arrowR from '@/assets/images/emergency/arrowR.png';
// import icon from '@/assets/images/emergency/icon.png';
// import iconArrow from '@/assets/images/emergency/iconArrow.png';
import arrowL from "@/assets/imgs/pics01.png";
import arrowR from "@/assets/imgs/pics01.png";
import icon from "@/assets/imgs/pics01.png";
import iconArrow from "@/assets/imgs/pics01.png";
export default {
  components: {},
  data() {
    return {
      selectedIndex:0,
      btnlist: [],
      progressList: [
        { type: "2", url: require("@/assets/imgs/pagesix/video802.jpg"),text:'搜狗搜索',videoUrl:require('@/assets/imgs/pagesix/video802.mp4') },
        { type: "2", url: require("@/assets/imgs/pagesix/video803.jpg"),text:'中粮',videoUrl:require('@/assets/imgs/pagesix/video803.mp4') },
        { type: "2", url: require("@/assets/imgs/pagesix/video804.jpg"),text:'裕园茶',videoUrl:require('@/assets/imgs/pagesix/video804.mp4') },
        { type: "2", url: require("@/assets/imgs/pagesix/video805.jpg"),text:'空格电影',videoUrl:require('@/assets/imgs/pagesix/video805.mp4') },
        { type: "2", url: require("@/assets/imgs/pagesix/video806.jpg"),text:'腾讯广告618',videoUrl:require('@/assets/imgs/pagesix/video806.mp4') },
        { type: "2", url: require("@/assets/imgs/pagesix/video807.jpg"),text:'腾讯金融 保洁阿姨养基秘笈',videoUrl:require('@/assets/imgs/pagesix/video807.mp4') },
        { type: "2", url: require("@/assets/imgs/pagesix/video808.jpg"),text:'优必选词典笔',videoUrl:require('@/assets/imgs/pagesix/video808.mp4') },
        { type: "2", url: require("@/assets/imgs/pagesix/video809.jpg"),text:'奥式生活',videoUrl:require('@/assets/imgs/pagesix/video809.mp4') },
        { type: "2", url: require("@/assets/imgs/pagesix/video810.jpg"),text:'一味一诚',videoUrl:require('@/assets/imgs/pagesix/video810.mp4') },
        { type: "2", url: require("@/assets/imgs/pagesix/video811.jpg"),text:'布啦叽家族',videoUrl:require('@/assets/imgs/pagesix/video811.mp4') },
        { type: "2", url: require("@/assets/imgs/pagesix/video812.jpg"),text:'菲力尔',videoUrl:require('@/assets/imgs/pagesix/video812.mp4') },
      ],
      progressListArr: [
        { type: "2", url: require("@/assets/imgs/pagesix/video802.jpg"),text:'搜狗搜索',videoUrl:require('@/assets/imgs/pagesix/video802.mp4') },
        { type: "2", url: require("@/assets/imgs/pagesix/video803.jpg"),text:'中粮',videoUrl:require('@/assets/imgs/pagesix/video803.mp4') },
        { type: "2", url: require("@/assets/imgs/pagesix/video804.jpg"),text:'裕园茶',videoUrl:require('@/assets/imgs/pagesix/video804.mp4') },
        { type: "2", url: require("@/assets/imgs/pagesix/video805.jpg"),text:'空格电影',videoUrl:require('@/assets/imgs/pagesix/video805.mp4') },
        { type: "2", url: require("@/assets/imgs/pagesix/video806.jpg"),text:'腾讯广告618',videoUrl:require('@/assets/imgs/pagesix/video806.mp4') },
        { type: "2", url: require("@/assets/imgs/pagesix/video807.jpg"),text:'腾讯金融 保洁阿姨养基秘笈',videoUrl:require('@/assets/imgs/pagesix/video807.mp4') },
        { type: "2", url: require("@/assets/imgs/pagesix/video808.jpg"),text:'优必选词典笔',videoUrl:require('@/assets/imgs/pagesix/video808.mp4') },
        { type: "2", url: require("@/assets/imgs/pagesix/video809.jpg"),text:'奥式生活',videoUrl:require('@/assets/imgs/pagesix/video809.mp4') },
        { type: "2", url: require("@/assets/imgs/pagesix/video810.jpg"),text:'一味一诚',videoUrl:require('@/assets/imgs/pagesix/video810.mp4') },
        { type: "2", url: require("@/assets/imgs/pagesix/video811.jpg"),text:'布啦叽家族',videoUrl:require('@/assets/imgs/pagesix/video811.mp4') },
        { type: "2", url: require("@/assets/imgs/pagesix/video812.jpg"),text:'菲力尔',videoUrl:require('@/assets/imgs/pagesix/video812.mp4') },


        // [{ type: "2", url: require("@/assets/imgs/pagesix/video204.jpg"),text:'2020体彩广告-去赛场篇',videoUrl:require('@/assets/imgs/pagesix/video204.mp4') },
        // { type: "1", url: require("@/assets/imgs/pagesix/video205.jpg"),text:'2020体彩广告-图个乐篇',videoUrl:require('@/assets/imgs/pagesix/video205.mp4') },
        // { type: "2", url: require("@/assets/imgs/pagesix/video206.jpg"),text:'2020体彩广告-五大联赛篇',videoUrl:require('@/assets/imgs/pagesix/video206.mp4') },
        // { type: "2", url: require("@/assets/imgs/pagesix/video208.jpg"),text:'2021体彩双向转化小视频',videoUrl:require('@/assets/imgs/pagesix/video208.mp4') },
        // { type: "2", url: require("@/assets/imgs/pagesix/video207.jpg"),text:'2020体彩锦鲤系列小视频',videoUrl:require('@/assets/imgs/pagesix/video207.mp4') },
        // { type: "1", url: require("@/assets/imgs/pagesix/video201.jpg"),text:'2019福彩双色球系列小视频',videoUrl:require('@/assets/imgs/pagesix/video201.mp4') },
        // { type: "1", url: require("@/assets/imgs/pagesix/video203.jpg"),text:'2020福彩双色球系列小视频',videoUrl:require('@/assets/imgs/pagesix/video203.mp4') },
        // { type: "2", url: require("@/assets/imgs/pagesix/video202.jpg"),text:'2020 7星彩为梦想添彩系列小视频',videoUrl:require('@/assets/imgs/pagesix/video202.mp4') },
        // { type: "2", url: require("@/assets/imgs/pagesix/video209.jpg"),text:'微软mv《Open Windows》',videoUrl:require('@/assets/imgs/pagesix/video209.mp4') },
        // { type: "2", url: require("@/assets/imgs/pagesix/video210.jpg"),text:'喜马拉雅vs腾讯视频双重会员TVC',videoUrl:require('@/assets/imgs/pagesix/video210.mp4') },
        // { type: "2", url: require("@/assets/imgs/pagesix/video211.jpg"),text:'bose耳机达人系列广告',videoUrl:require('@/assets/imgs/pagesix/video211.mp4') }],


        // [{ type: "1", url: require("@/assets/imgs/pagesix/video301.jpg"),text:'福彩手工艺大赛系列专题片',videoUrl:require('@/assets/imgs/pagesix/video301.mp4') },
        // { type: "2", url: require("@/assets/imgs/pagesix/video302.jpg"),text:'腾讯云访谈',videoUrl:require('@/assets/imgs/pagesix/video302.mp4') },
        // { type: "1", url: require("@/assets/imgs/pagesix/video303.jpg"),text:'腾讯云营销加乘计划',videoUrl:require('@/assets/imgs/pagesix/video303.mp4') },
        // { type: "2", url: require("@/assets/imgs/pagesix/video304.jpg"),text:'腾讯自选股街采',videoUrl:require('@/assets/imgs/pagesix/video304.mp4') },
        // ],



        // [{ type: "1", url: require("@/assets/imgs/pagesix/video401.jpg"),text:'厂养鸡 欧洲杯433阵型',videoUrl:require('@/assets/imgs/pagesix/video401.mp4') },
        // { type: "2", url: require("@/assets/imgs/pagesix/video402.jpg"),text:'鹅厂养鸡 公募reits',videoUrl:require('@/assets/imgs/pagesix/video402.mp4') },
        // { type: "1", url: require("@/assets/imgs/pagesix/video403.jpg"),text:'鹅厂养鸡 欧洲杯',videoUrl:require('@/assets/imgs/pagesix/video403.mp4') },
        // { type: "2", url: require("@/assets/imgs/pagesix/video404.jpg"),text:'鹅厂养鸡 ESG基金',videoUrl:require('@/assets/imgs/pagesix/video404.mp4') },
        // { type: "1", url: require("@/assets/imgs/pagesix/video405.jpg"),text:'基金相声 腾讯金融',videoUrl:require('@/assets/imgs/pagesix/video405.mp4') },
        // { type: "2", url: require("@/assets/imgs/pagesix/video406.jpg"),text:'理财观念 新华社',videoUrl:require('@/assets/imgs/pagesix/video406.mp4') },
        // { type: "2", url: require("@/assets/imgs/pagesix/video407.jpg"),text:'腾讯算法大赛招聘动画',videoUrl:require('@/assets/imgs/pagesix/video407.mp4') },
        // { type: "2", url: require("@/assets/imgs/pagesix/video408.jpg"),text:'腾讯新闻 回家过年',videoUrl:require('@/assets/imgs/pagesix/video408.mp4') },
        // { type: "2", url: require("@/assets/imgs/pagesix/video409.jpg"),text:'一点资讯年终大事盘点',videoUrl:require('@/assets/imgs/pagesix/video409.mp4') },
        // ],
      ],
      arrowL,
      arrowR,
      icon,
      iconArrow,
      currentProgressId: "",
      scrollResultWidth: 0, //transform滚动的距离
      signleWidth: 215, //单个流程的宽度
      activeName: 0,
      currentClickNumber: 0,
      noScrollRight: true
    };
  },
  
  mounted() {
    this.$nextTick(() => {
      // 在dom渲染完后,再执行动画
      // const wow = new WOW({
      //   live: false
      // })
      // wow.init()
      new this.$wow.WOW({
        live:true
      }).init()
    })
    setTimeout(() => {
      this.signleWidth =
        ((document.documentElement.clientWidth / 24) * 22 - 10) / 2;
      for (let i = 0; i < this.$refs.aaa.length; i++) {
        this.$refs.aaa[i].style.width = this.signleWidth + "px";
      }
      // setTimeout(() => {
      // this.initHeight = this.$refs.imgsIcon[0].clientHeight
      // this.$refs.prevBtn.style.top = (this.initHeight - 55)/2 + 'px'
      // this.$refs.nextBtn.style.top = (this.initHeight - 55)/2 + 'px'
      // console.log(this.$refs.prevBtn,'initHeight')
      // }, 1000);
    }, 1000);
  },
  created() {
    this.$nextTick(() => {
      setTimeout(() => {
        this.initgoRightArrow();
      });
    });
  },
  methods: {
    selectPics(item){
      this.$emit('selectPics',item)
    },
    //初始化判断是否可以向右滚动
    initgoRightArrow() {
      const currentScrollWidth = this.$refs[`fixedBox`].clientWidth;
      const canNumber = Math.floor(currentScrollWidth / this.signleWidth); //可以放下的个数
      //如果最后一个流程图标已经展示出来，则停止滚动
      if (this.currentClickNumber + canNumber >= this.progressList.length) {
        this.noScrollRight = false;
        return;
      }
    },
    //点击上一个
    fnPrev() {
      //如果右点击的次数大于0，才可以左滚
      if (this.currentClickNumber > 0) {
        this.currentClickNumber -= 1;
        this.noScrollRight = true;
        this.fnScrollWidth("reduce");
      } else {
        return false;
      }
    },
    picsFn(index){

      setTimeout(() => {
      this.signleWidth =
        ((document.documentElement.clientWidth / 24) * 22 - 10) / 2;
      for (let i = 0; i < this.$refs.aaa.length; i++) {
        this.$refs.aaa[i].style.width = this.signleWidth + "px";
      }
    }, 1000);


        this.selectedIndex = index
        console.log(111)
        this.progressList = this.progressListArr[index]
        // this.scrollResultWidth = 0

        this.currentProgressId=""
      this.scrollResultWidth=0 //transform滚动的距离
    //   this.signleWidth=215 //单个流程的宽度
      this.activeName=0
      this.currentClickNumber=0
      this.noScrollRight=true
    },
    //点击下一个
    fnNext() {
      const currentScrollWidth = this.$refs[`fixedBox`].clientWidth;
      const canNumber = Math.floor(currentScrollWidth / this.signleWidth); //可以放下的个数
      //如果最后一个流程图标已经展示出来，则停止滚动
      if (this.currentClickNumber + canNumber >= this.progressList.length) {
        return;
      }
      //说明放不下有滚动条
      if (this.progressList.length > canNumber) {
        this.currentClickNumber += 1;
        if (this.currentClickNumber + canNumber >= this.progressList.length) {
          this.noScrollRight = false;
        }
        this.fnScrollWidth("add");
      }
    },
    //translate的宽度
    fnScrollWidth(type) {
      let result = 0;
      if (type === "reduce") {
        result = this.signleWidth + 10;
      } else if (type === "add") {
        result = -this.signleWidth - 10;
      } else {
        result = 0;
      }
      this.scrollResultWidth += result;
    }
  }
};
</script>
<style lang="less" scoped>
.mobile_wrap_short1{
  .ProgressBoxTool{
    position: relative;
  }
  .prevBtn{
    width: 40px;
    height: 40px;
    // position: absolute;
    // left: -20px;
    // top: 97.5px;
    z-index: 1;
    position: absolute;
    top: 50%;
    left: 0%;
    transform: translate(-16px, -50%);

    .server_img{
      width: 40px;
      height: 40px;
    }
  }
  .nextBtn{
    width: 40px;
    height: 40px;
    // position: absolute;
    // right: -20px;
    // top: 97.5px;
    z-index: 1;
    position: absolute;
    top: 50%;
    right: 0%;
    transform: translate(16px, -50%);

    .server_img{
      width: 40px;
      height: 40px;
    }
  }
  .posts-nav-wrap{text-align:center;width:100%;height:32px;display:inline-block;clear:both;}

.posts-nav li{margin:0 13px 0 0;display:inline-block;box-shadow: 0 5px 10px 0 rgba(0, 0, 0, .05);}

.posts-nav li a{text-indent:-9999em;text-align:left;-moz-border-radius:5px;-webkit-border-radius:5px;border-radius:5px;display:inline-block;-moz-transition:all .20s ease-in-out;-webkit-transition:all .20s ease-in-out;transition:all .20s ease-in-out;}

.posts-nav .next a{background:#a4a4a4 url(../assets/imgs/ico-pagination-arrow-next.png) no-repeat center;width:144px;height:32px;line-height:32px;outline: none;}
.posts-nav .next a:hover{cursor: pointer; text-decoration:none;background:#e91d62 url(../assets/imgs/ico-pagination-arrow-next.png) no-repeat 110px center;}

.posts-nav .previous a{width:64px;height:32px;line-height:32px;background-color:#a4a4a4;background-image:url(../assets/imgs/ico-pagination-arrow-previous.png);background-position:center;background-repeat:no-repeat;outline: none;}
.posts-nav .previous a:hover{cursor: pointer;text-decoration:none;background:#e91d62 url(../assets/imgs/ico-pagination-arrow-previous.png) no-repeat 12px center;}

.casepage{
  background: #f6f6f8;
}
.wrap_btn {
  display: flex;
  // float: right;
  height: 50px;
  justify-content: center;
  .btn_block {
    width: 90px;
    height: 30px;
    line-height: 30px;
    border-radius: 20px;
    text-align: center;
    font-size: 14px;
    margin-right: 12px;
    color: #fff;
    border: 1px solid #e91d62;
    color: #e91d62;
    // background: #e91d62;
  }
  .active{
    color: #e91d62;
    border:1px solid #e91d62;
  }
}
.header_block {
  min-height: 10px;
}
//中间的时间发展部分
.processBox {
  display: flex;
  align-items: center;
  justify-content: space-between;
  .arrow {
    width: 60px;
    cursor: pointer;
  }
  .arrowOpacity {
    cursor: default;
    opacity: 0.4;
  }
  .fixedBox {
    flex: 1;
    overflow: hidden;
  }
  .centerScroll {
    // flex: 1;
    box-sizing: border-box;
    padding: 20px 0;
    white-space: nowrap;
    // width: calc(100% - 120px);
    // overflow-x: auto;
    .signleTab {
      //   width: 215px;
      position: relative;
      display: inline-block;
      margin-right: 10px;
      //   .leftIcon {
      //     width: 150px;
      //     text-align: center;
      //     cursor: pointer;
      //     & > .pregressIcon {
      //       width: 60px;
      //       height: 60px;
      //     }
      //   } 
      .pregressIcon {
        width: 100%;
        // height: 250px;
      }
      .mask_title{
        font-size: 14px;
        color: #666;
        width: 100%;
        z-index: 3;
        text-align: center;
        height: 60px;
        line-height: 50px;
        /* border-radius: 0px 0px 5px 5px; */
      }
      & > .arrowSquare {
        position: absolute;
        top: 25px;
        right: 0;
      }
    }
  }
}
}
</style>
 